"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewportHeight = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var useViewportHeight = function useViewportHeight(isIOSSafari) {
  var _useState = (0, _react.useState)(window.innerHeight),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    vh = _useState2[0],
    setVh = _useState2[1];
  (0, _react.useEffect)(function () {
    var throttledScrollEvent = (0, _lodash.default)(function () {
      setVh(window.innerHeight);
    });
    if (!isIOSSafari) return;
    window.addEventListener('scroll', throttledScrollEvent);
    return function () {
      window.removeEventListener('scroll', throttledScrollEvent);
    };
  }, [isIOSSafari, setVh]);
  return {
    vh: vh
  };
};
exports.useViewportHeight = useViewportHeight;